import { gql } from '../__generated__'

export const SEARCH_PRODUCTION_UNIT_TYPES = gql(`
  query SearchProductionUnitTypes($input: ProductionUnitTypeSearchInput!, $after: String, $first: Int) {
    searchProductionUnitTypes(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...ProductionUnitTypeFragment
      }
    }
  }
`)

export const SEARCH_PRODUCTION_UNIT_LABELS = gql(`
  query SearchProductionUnitLabels($input: ProductionUnitLabelSearchInput!, $after: String, $first: Int) {
    searchProductionUnitLabels(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...ProductionUnitLabelFragment
      }
    }
  }
`)

export const SEARCH_ORDER_LABELS = gql(`
  query SearchOrderLabels($input: OrderLabelSearchInput!, $after: String, $first: Int) {
    searchOrderLabels(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...OrderLabelFragment
      }
    }
  }
`)

export const SEARCH_JOB_TITLES = gql(`
  query SearchJobTitles($input: JobTitleSearchInput!, $after: String, $first: Int) {
    searchJobTitles(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...JobTitleFragment
      }
    }
  }
`)

export const SEARCH_GARMENT_FAMILIES = gql(`
  query SearchGarmentFamilies($input: GarmentFamilySearchInput!, $after: String, $first: Int) {
    searchGarmentFamilies(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...GarmentFamilyFragment
        garmentTypes {
          ...GarmentTypeFragment
          previews {
            id
            isDefault
            url
          }
        }
      }
    }
  }
`)

export const SEARCH_FILE_CATEGORIES = gql(`
  query SearchFileCategories($input: FileCategorySearchInput!, $after: String, $first: Int) {
    searchFileCategories(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...FileCategoryFragment
      }
    }
  }
`)

export const SEARCH_GARMENT_NODES = gql(`
  query SearchGarmentNodes($input: GarmentNodeSearchInput!, $after: String, $first: Int) {
    searchGarmentNodes(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...GarmentNodeFragment
      }
    }
  }
`)

export const SEARCH_SEASONS = gql(`
  query SearchSeasons($input: SeasonSearchInput!, $after: String, $first: Int) {
    searchSeasons(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...SeasonFragment
      }
    }
  }
`)

export const ALL_MACHINE_TYPES = gql(`
  query AllMachineTypes {
    allMachineTypes {
      ...MachineTypeFragment
    }
  }
`)

export const ALL_GARMENT_TYPES = gql(`
  query AllGarmentTypes {
    allGarmentTypes {
      ...GarmentTypeFragment
    }
  }
`)

export const GET_GARMENT_TYPE = gql(`
  query GetGarmentType($id: ID!) {
    getGarmentType(id: $id) {
      ...GarmentTypeFragment
      previews {
        ...GarmentTypePreviewFragment
      }
    }
  }
`)

export const ALL_SYSTEM_GARMENT_PREVIEWS = gql(`
  query AllSystemGarmentPreviews {
    allSystemGarmentPreviews {
      ...SystemGarmentPreviewFragment
    }
  }
`)

export const SEARCH_SIZE_STANDARDS = gql(`
  query SearchSizeStandards($input: SizeStandardSearchInput!, $after: String, $first: Int) {
    searchSizeStandards(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...SizeStandardFragment
      }
    }
  }
`)

export const SEARCH_DROPDOWN_SIZE_STANDARDS = gql(`
  query SearchDropdownSizeStandards($input: SizeStandardSearchInput!, $after: String, $first: Int) {
    searchSizeStandards(input: $input, after: $after, first: $first) {
      nodes {
        id
        active
        name
        sizes {
        ...SizeFragment
        }
      }
    }
  }
`)

export const SEARCH_CLIENTS = gql(`
  query SearchClients($input: ClientSearchInput!, $after: String, $first: Int) {
    searchClients(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...ClientFragment
      }
    }
  }
`)

export const SEARCH_DROPDOWN_CLIENTS = gql(`
  query SearchDropdownClients($input: ClientSearchInput!, $after: String, $first: Int) {
    searchClients(input: $input, after: $after, first: $first) {
      nodes {
        id
        name
        active
      }
    }
  }
`)

export const SEARCH_PRODUCERS = gql(`
  query SearchProducers($input: ProducerSearchInput!, $after: String, $first: Int) {
    searchProducers(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...ProducerFragment
      }
    }
  }
`)

export const GET_PRODUCTION_UNIT = gql(`
  query GetProductionUnit($id: ID!) {
    getProductionUnit(id: $id) {
      ...CachedProductionUnitFragment
      contributors {
        account {
          ...AccountFragment
        }
        removable
      }
    }
  }
`)

export const GET_PRODUCTION_UNIT_WORK_DAYS = gql(`
  query GetProductionUnitWorkDays($id: ID!, $startDate: Timestamp!, $endDate: Timestamp!) {
    getProductionUnit(id: $id) {
      id
      workDays(startDate: $startDate, endDate: $endDate)
    }
  }
`)

export const GET_ASSIGNABLE_PRODUCTION_UNIT_CONTRIBUTORS = gql(`
  query GetAssignableProductionUnitContributors {
    getAssignableProductionUnitContributors {
      ...AccountFragment
    }
  }
`)

export const GET_AUTO_ASSIGNED_PRODUCTION_UNIT_CONTRIBUTORS = gql(`
  query GetAutoAssignedProductionUnitContributors {
    getAutoAssignedProductionUnitContributors {
      ...AccountFragment
    }
  }
`)

export const ALL_PRODUCTION_UNITS = gql(`
  query AllProductionUnits {
    allProductionUnits {
      ...ProductionUnitFragment
    }
  }
`)

export const ALL_PRODUCTION_UNITS_FOR_PROD_ORDER = gql(`
  query AllProductionUnitsForProdOrder {
    allProductionUnits {
      ...CachedProductionUnitFragment
      activeProductionOrdersCount
    }
  }
`)

export const SEARCH_BASE_PROCESSES = gql(`
  query SearchBaseProcesses($input: BaseProcessSearchInput!, $after: String, $first: Int) {
    searchBaseProcesses(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...BaseProcessFragment
      }
    }
  }
`)

export const ALL_OPERATORS = gql(`
  query AllOperators {
    allOperators {
      ...OperatorFragment
    }
  }
`)

export const GET_OPERATOR = gql(`
  query GetOperator($getOperatorId: ID!) {
    getOperator(id: $getOperatorId) {
      ...OperatorFullFragment
    }
  }
`)

export const SEARCH_EARNING_RATES = gql(`
  query SearchEarningRates($input: EarningRateSearchInput!, $after: String, $first: Int) {
    searchEarningRates(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...EarningRateFragment
      }
    }
  }
`)

export const SEARCH_VARIANT_ATTRIBUTE_DEFINITIONS = gql(`
  query searchAttributeDefinitions($input: AttributeDefinitionSearchInput!, $after: String, $first: Int) {
    searchAttributeDefinitions(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...AttributeDefinitionFragment
      }
    }
  }
`)

export const SEARCH_CUTTING_MATERIAL_TYPES = gql(`
  query SearchCuttingMaterialTypes($input: CuttingMaterialTypeSearchInput!, $after: String, $first: Int) {
    searchCuttingMaterialTypes(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
       ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...CuttingMaterialTypeFragment
      }
    }
  }
`)

export const ALL_TEAMS = gql(`
  query AllTeams {
    allTeams {
      ...TeamFragment
    }
  }
`)

export const SEARCH_TEAMS = gql(`
  query SearchTeams($input: TeamSearchInput!, $after: String, $first: Int) {
    searchTeams(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...TeamFragment
      }
    }
  }
`)

export const SEARCH_BUNDLE_TEMPLATES = gql(`
  query SearchBundleTemplates($input: BundleTemplateSearchInput!, $after: String, $first: Int) {
    searchBundleTemplates(input: $input, after: $after, first: $first) {
      totalElements
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
      }
      nodes {
        ...BundleTemplateFragment
      }
    }
  }
`)
